import React, { useRef } from "react";
import styled from "styled-components";
import { Spacing, content } from "@glossy";
import { Locale } from "@linkfluence/models/locale";
import { Timezone } from "@linkfluence/models/timezone";
import {
  Influencer,
  InfluencerLensFactory,
} from "@radarly/models/influencer/index";
import { Project } from "@radarly/models/project";
import AuthorDetails from "./details";
import AuthorHead from "./head";
import AuthorMetrics from "./metrics";
import AuthorPlatform from "./platform";

interface IProps {
  influencer: Influencer;
  project?: Project;
  timezone: Timezone;
  locale?: Locale;
  className?: string;
}

const Root = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  color: ${content};
`;

const Main = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-width: 0;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: center;
  gap: ${Spacing.Small};
`;

const RadarlyAuthor = ({ influencer, locale, className }: IProps) => {
  const ref = useRef();
  const influencerLens = InfluencerLensFactory.create(influencer);

  return (
    <Root ref={ref} className={className}>
      <Main>
        <Wrapper>
          <AuthorHead influencerLens={influencerLens} />
          <AuthorDetails influencerLens={influencerLens} locale={locale} />
          <AuthorMetrics metrics={influencerLens.getAccountMetrics()} />
        </Wrapper>
        <AuthorPlatform platform={influencer.platform} />
      </Main>
    </Root>
  );
};

export default RadarlyAuthor;
